import { Navigate, useRoutes } from 'react-router-dom';

// project-imports
import LoginRoutes from './LoginRoutes';
import MainRoutes from './MainRoutes';
import { APP_DEFAULT_PATH } from 'config';

// ==============================|| ROUTES RENDER ||============================== //
//
// The exact "/" redirect lives here, as its own top-level leaf, rather than nested inside
// AuthGuard's protected tree. Nested there, it raced AuthGuard's own effect-driven redirect to
// /login — both fired on the same mount — and depending on which won, "/" could render nothing at
// all: MainLayout mounts unconditionally before AuthGuard's effect has a chance to redirect away.

export default function ThemeRoutes() {
  return useRoutes([{ path: '/', element: <Navigate to={APP_DEFAULT_PATH} replace /> }, LoginRoutes, MainRoutes]);
}
